import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavController, NavParams, ToastController } from "ionic-angular";
import { AlertController, LoadingController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Songs } from "../../models/interfaces/songs.model";
import { Status } from "../../models/interfaces/status.model";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-songs_update",
  templateUrl: "songs_update.html",
})
export class SongsUpdatePage {
  private loading: any;
  private songs$: Observable<Songs[]>;
  private songsForm: FormGroup;
  private so_id: number;
  private so_text: string;
  private so_title: string;
  private so_order: number;
  private styleName: string ="";
  private songs: Songs;
  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, private toastCtrl: ToastController,
    private db: DbserviceProvider, public alertCtrl: AlertController, public loadingCtrl: LoadingController,
  ) {
    console.log("SongsAddPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.so_id = this.navParams.get("song").so_id;

    this.songsForm = this.formBuilder.group({
      "so_id": [this.navParams.get("song").so_id, [Validators.required]],
      "so_order": [this.navParams.get("song").so_order],
      "so_text": [this.navParams.get("song").so_text, [Validators.required]],
      "so_title": [this.navParams.get("song").so_title, [Validators.required]],
    });
  }
  private ionViewWillEnter() {
    console.log("SongsAddPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("SongsAddPage onInitPage");
  }

  private goback() {
    console.log("SongsAddPage goback");
    this.navCtrl.pop();
  }

  private updateSong(value) {
    console.log("SongsAddPage updateSong");
    if (this.songsForm.dirty && this.songsForm.valid) {

      const formValues: any = {
        "so_id": value.so_id,
        "so_order": value.so_order,
        "so_text": value.so_text,
        "so_title": value.so_title,
      };

      this.db.dbCol({ "action": "update", "mapObject": "songs", ...formValues })
        .subscribe((ret3) => {
          this.navCtrl.pop();
        });
    }
  }

  private ngOnDestroy() {
    console.log("SongsAddPage ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./src/pages/songs/songs_update.ts